import { useContext } from 'react';
import { SelectorRegisterContext } from './SelectorRegisterProvider';

export default function useSelectorRegister() {
    return useContext(SelectorRegisterContext);
}
